import { Button } from '@mui/material';
import { ApplicationSubmitForm } from '~/modules/processing-personal/PersonalDataApplicationForm/PersonalDataApplicationSubmit/ApplicationSubmitForm/ApplicationSubmitForm.tsx';
import { ApplicationDocumentPreview } from '~/modules/processing-personal/PersonalDataApplicationForm/components/ApplicationDocumentPreview.tsx';
import { ApplicationWhyRevokeForm } from '~/modules/processing-personal/PersonalDataApplicationForm/PersonalDataApplicationSubmit/components/ApplicationWhyRevokeForm.tsx';
import { FormButtonGroup } from '../../components/styled.ts';
import { FormDataSubmit } from '../types.ts';

interface IApplicationStepContentProps {
  current: number;
  formData?: FormDataSubmit;
  isSubmitting: boolean;
  onPrev: () => void;
  onNext: () => void;
  onOptionSignature: () => void;
}

export const ApplicationStepContent = ({
  current,
  formData,
  isSubmitting,
  onPrev,
  onNext,
  onOptionSignature,
}: IApplicationStepContentProps) => {
  const renderContent = () => {
    switch (current) {
      case 1:
        return <ApplicationSubmitForm formData={formData} />;
      case 2:
        return <ApplicationDocumentPreview />;
      case 3:
        return <ApplicationWhyRevokeForm />;
      default:
        return null;
    }
  };

  const renderButtons = () => (
    <FormButtonGroup>
      {current > 2 && (
        <Button
          variant="outlined"
          color="primary"
          type="button"
          onClick={onPrev}
          disabled={isSubmitting}
        >
          Повернутись
        </Button>
      )}

      {current === 1 && (
        <Button variant="contained" color="primary" type="submit" disabled={isSubmitting}>
          Продовжити
        </Button>
      )}

      {current === 2 && (
        <>
          <Button
            variant="outlined"
            color="primary"
            type="button"
            onClick={onNext}
            disabled={isSubmitting}
          >
            Відмовитись
          </Button>
          <Button
            variant="contained"
            color="primary"
            type="button"
            onClick={onOptionSignature}
            disabled={isSubmitting}
          >
            Підписати
          </Button>
        </>
      )}

      {current === 3 && (
        <Button variant="contained" color="primary" type="submit" disabled={isSubmitting}>
          Завершити
        </Button>
      )}
    </FormButtonGroup>
  );

  return (
    <>
      {renderContent()}
      {renderButtons()}
    </>
  );
};
